
export class Obj {
/**
 * Returns whether the given object is not null and not undefined
 * @param {?} obj
 * @return {?}
 */
public static isNotNullOrUndefined(obj: any): boolean {
    return obj !== null && obj !== undefined;
  }
/**
 * Returns whether the given object is null or undefined
 * @param {?} obj
 * @return {?}
 */
public static isNullOrUndefined(obj: any): boolean {
    return !Obj.isNotNullOrUndefined(obj);
  }
/**
 * Returns a clone of the given object
 * @param {?} obj
 * @return {?}
 */
public static clone(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
  }
/**
 * Returns whether the two objects are equal
 * @param {?} obj1
 * @param {?} obj2
 * @return {?}
 */
public static equals(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }
/**
 * Returns whether the given object has the given key
 * @param {?} obj
 * @param {?} key
 * @return {?}
 */
public static hasKey(obj: any, key: string|number): boolean {
    return Obj.isNotNullOrUndefined(obj) && obj.hasOwnProperty(key);
  }
}